import { Injectable } from '@angular/core';

import { modelosRoute } from "./data.service";
import { AuthService } from "../../../shared/services/auth.service";
import { editRoute, newRoute } from "../../../shared/services/data.service";
import {marcasRoute} from "../../marcas/shared/data.service";
import {bensRoute} from "../../shared/data.service";

@Injectable()
export class ModeloNavigationService {
  moduleRouter: string = modelosRoute;
  marcasRouter: string = marcasRoute;
  fatherRouter: string = bensRoute;

  constructor(
    private _authService: AuthService
  ) { }

  goToList() {
    var router: string = this.fatherRouter + '/' + this.marcasRouter;
    this._authService.navigateTo(router);
  }

  goToNew() {
    var router: string = this.fatherRouter + '/' + this.moduleRouter + '/' + newRoute;
    this._authService.navigateTo(router);
  }

  goToEdit(objectId: number) {
    var router: string = this.fatherRouter + '/' + this.moduleRouter + '/' + editRoute;
    this._authService.navigateTo(router, objectId);
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/modelos/shared/modelo-navigation.service.ts
 **/